/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_DeInputs */

const en_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const es_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const de_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const zh_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const ar_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const fr_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const vi_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const sw_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const th_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const bs_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const ja_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const ko_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const pt_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const it_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const sv_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const nl_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const da_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const nb_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const fi_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const pl_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const ru_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const tr_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const hi_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const id_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const ms_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const cs_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const el_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const he_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const af_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const hu_nav_language_de = /** @type {(inputs: Nav_Language_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "Deutsch" |
*
* @param {Nav_Language_DeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_de = /** @type {((inputs?: Nav_Language_DeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_DeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_de(inputs)
	if (locale === "de") return de_nav_language_de(inputs)
	if (locale === "zh") return zh_nav_language_de(inputs)
	if (locale === "ar") return ar_nav_language_de(inputs)
	if (locale === "fr") return fr_nav_language_de(inputs)
	if (locale === "vi") return vi_nav_language_de(inputs)
	if (locale === "sw") return sw_nav_language_de(inputs)
	if (locale === "th") return th_nav_language_de(inputs)
	if (locale === "bs") return bs_nav_language_de(inputs)
	if (locale === "ja") return ja_nav_language_de(inputs)
	if (locale === "ko") return ko_nav_language_de(inputs)
	if (locale === "pt") return pt_nav_language_de(inputs)
	if (locale === "it") return it_nav_language_de(inputs)
	if (locale === "sv") return sv_nav_language_de(inputs)
	if (locale === "nl") return nl_nav_language_de(inputs)
	if (locale === "da") return da_nav_language_de(inputs)
	if (locale === "nb") return nb_nav_language_de(inputs)
	if (locale === "fi") return fi_nav_language_de(inputs)
	if (locale === "pl") return pl_nav_language_de(inputs)
	if (locale === "ru") return ru_nav_language_de(inputs)
	if (locale === "tr") return tr_nav_language_de(inputs)
	if (locale === "hi") return hi_nav_language_de(inputs)
	if (locale === "id") return id_nav_language_de(inputs)
	if (locale === "ms") return ms_nav_language_de(inputs)
	if (locale === "cs") return cs_nav_language_de(inputs)
	if (locale === "el") return el_nav_language_de(inputs)
	if (locale === "he") return he_nav_language_de(inputs)
	if (locale === "af") return af_nav_language_de(inputs)
	if (locale === "hu") return hu_nav_language_de(inputs)
	return en_nav_language_de(inputs)
});